import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Horse } from '@models/horse.model';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, mergeMap, tap } from 'rxjs/operators';
import { HorseService } from '@store/horses-store/services/horse.service';

@Component({
  selector: 'app-select-horse',
  templateUrl: './select-horse.component.html',
  styleUrls: ['./select-horse.component.scss'],
})
export class SelectHorseComponent implements OnInit {
  @Input() searchTerm: FormControl;
  @Input() horseId: string;
  @Output() horse: EventEmitter<Horse> = new EventEmitter<Horse>();

  horses$: Observable<any>;

  constructor(private horseService: HorseService) { }

  ngOnInit() {
    this.horses$ = this.searchTerm.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      mergeMap((term) => this.horseService.searchHorseWithTerm(term))
    )
  }

  displayFn(horse): string {
    return horse && horse.name ? `${horse.name}` : '';
  }
}
